export enum ECaseType {
  NO_COLOR,
  BLUE,
  DARK_BLUE,
  PURPLE,
  LIGHT_PURPLE,
  RED,
  YELLOW,
  SUPER_PRIZE,
}
